/**
 * Public mail providers. A "Never capture" domain entry for one of these
 * skips everyone who uses that provider, customers included, so the UI warns
 * (without blocking) when one is typed.
 */
export const PUBLIC_MAIL_DOMAINS: ReadonlySet<string> = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'msn.com',
])

/**
 * The public mail provider a typed "Never capture" value would block as a
 * whole domain, or null. Mirrors the server's reading of a pattern: `x.com`
 * and `@x.com` are domains, `name@x.com` is one address (no warning).
 */
export function publicMailDomainOf(value: string): string | null {
  const trimmed = value.trim().toLowerCase()
  const domain = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed
  if (!domain || domain.includes('@')) return null
  return PUBLIC_MAIL_DOMAINS.has(domain) ? domain : null
}

/** Warning shown under the input for a public mail provider domain. */
export function publicDomainWarning(domain: string): string {
  return `This skips mail from everyone at ${domain}, customers included.`
}

/** Success toast title after an entry is added. */
export function neverCaptureAddedMessage(pattern: string): string {
  return `${pattern} won't be captured anymore`
}

/** Toast detail when the add also deleted saved mail. */
export function wipedMessagesDescription(count: number): string | undefined {
  if (count <= 0) return undefined
  return `Deleted ${count} ${count === 1 ? 'message' : 'messages'}`
}
